const START_MESSAGE = "start";
const LEAVE_MESSAGE = "leave";
const RANDOM_ACCESS_MESSAGE = "random-access";
const DONE_CLEARING_MESSAGE = "done-clearing";
function constructStartMessage(id) {
  return { action: START_MESSAGE, id };
}
function constructLeaveMessage(id) {
  return { action: LEAVE_MESSAGE, id };
}
function constructRandomAccessMessage(id, index) {
  return {
    action: RANDOM_ACCESS_MESSAGE,
    id,
    index
  };
}
export {
  DONE_CLEARING_MESSAGE,
  LEAVE_MESSAGE,
  RANDOM_ACCESS_MESSAGE,
  START_MESSAGE,
  constructLeaveMessage,
  constructRandomAccessMessage,
  constructStartMessage
};
